import axios from "../api/axios";
import React from "react";
import useAuth from "../hooks/useAuth";
import { useStateIfMounted } from "use-state-if-mounted";
import Utils from "../utils";

const LOGIN_URL = "/wp-json/api-bearer-auth/v1/login";

const inputClass = "h-12 w-full border border-line bg-white px-3 text-[15px] outline-none transition-colors duration-200 focus:border-ink";
const labelClass = "mb-2 block text-[11px] font-extrabold uppercase tracking-eyebrow text-muted";

const LoginForm = ({onSuccess}) => {

	const [user, setUser] = useStateIfMounted("");
	const [password, setPassword] = useStateIfMounted("");
	const [errorMessage, setErrorMessage] = useStateIfMounted("");
	const { setAuth } = useAuth();
	const [isLoading, setIsLoading] = useStateIfMounted(false);

	const handleSubmit = async (e) => {
		e.preventDefault();

		setIsLoading(true);

		try {
			const response = await axios.post(LOGIN_URL,
				{
					username: user,
					password: password
				},
				{
					headers: {"Content-type": "application/json"},
					withCredentials: true
				}
			);

			// Save profile data compressed in local storage
			if (response?.data?.profile_data) {
				window.localStorage.setItem("userProfileData", Utils.compressString(JSON.stringify(response?.data?.profile_data)));
			}

			const accessToken = response?.data?.access_token;

			setAuth({ user, accessToken });
			setUser("");
			setPassword("");
			setErrorMessage("");

			onSuccess();

		} catch(err) {
			if(!err?.response) {
				setErrorMessage("No hubo respuesta del servidor");
			} else if(err.response?.status === 401) {
				setErrorMessage("Usuario o contraseña incorrecta");
			} else {
				setErrorMessage("No se pudo iniciar sesión");
			}
			console.error(err);
		} finally {
			setIsLoading(false);
		}
	};


	return (
		<form onSubmit={handleSubmit} className="px-7 pb-9 pt-11 sm:px-11">
			<p className="eyebrow">Área de clientes</p>
			<h2 className="mb-8 mt-3 text-[38px] leading-none tracking-headline font-semibold">Ingresar</h2>

			<div className="mb-5">
				<label htmlFor="username" className={ labelClass }>Usuario</label>
				<input
					type="text"
					id="username"
					autoComplete="off"
					onChange={(e) => setUser(e.target.value)}
					value={user}
					required
					className={ inputClass }
				/>
			</div>

			<div className="mb-7">
				<label htmlFor="password" className={ labelClass }>Contraseña</label>
				<input
					type="password"
					id="password"
					onChange={(e) => setPassword(e.target.value)}
					value={password}
					required
					className={ inputClass }
				/>
			</div>

			<button disabled={isLoading} className="button button--primary w-full disabled:opacity-70">
				{ isLoading ? "Ingresando…" : "Ingresar" }
			</button>

			{
				errorMessage &&
					<p className="mt-4 text-sm text-[#8b2635]" role="alert">{ errorMessage }</p>
			}
		</form>
	);
};

export default LoginForm;
